import { userActionTypes } from '../actionTypes';
import api from 'utils/api';

export const getCurrentUser = () => async dispatch => {
  try {
    dispatch({ type: userActionTypes.GET_CURRENT_USER_START });
    const { data } = await api.get('/me');
    dispatch({ type: userActionTypes.GET_CURRENT_USER, payload: data });
  } catch (err) {
    dispatch({ type: userActionTypes.GET_CURRENT_USER_ERROR, payload: err });
  }
};

export const logOut = () => dispatch => {
  localStorage.removeItem('accessToken');
  dispatch({ type: userActionTypes.LOGOUT_USER });
};

export const logIn = userData => async dispatch => {
  try {
    dispatch({ type: userActionTypes.LOGIN_USER_START });
    const { data } = await api.post('/login', userData);
    localStorage.setItem('accessToken', data);
    dispatch({ type: userActionTypes.LOGIN_USER });
  } catch (err) {
    dispatch({ type: userActionTypes.LOGIN_USER_ERROR, payload: err });
  }
};

export const signUp = userData => async dispatch => {
  try {
    dispatch({ type: userActionTypes.SIGN_UP_USER_START });
    await api.post('/register', userData);
    dispatch({ type: userActionTypes.SIGN_UP_USER });
  } catch (err) {
    dispatch({ type: userActionTypes.SIGN_UP_USER_ERROR, payload: err });
  }
};

export const verifyUser = verifyToken => async dispatch => {
  try {
    dispatch({ type: userActionTypes.VERIFY_USER_START });
    const { data } = await api.post('/verify-user', verifyToken);
    localStorage.setItem('accessToken', data);
    dispatch({ type: userActionTypes.VERIFY_USER });
  } catch (err) {
    dispatch({ type: userActionTypes.VERIFY_USER_ERROR, payload: err });
  }
};

export const setIsLoggedIn = () => dispatch =>
  dispatch({ type: userActionTypes.SET_IS_LOGGED_IN });

export const getAllEmployees = () => async dispatch => {
  try {
    dispatch({ type: userActionTypes.GET_ALL_EMPLOYEES_START });
    const { data } = await api.get('/all-employees');
    dispatch({ type: userActionTypes.GET_ALL_EMPLOYEES, payload: data });
  } catch (err) {
    dispatch({ type: userActionTypes.GET_ALL_EMPLOYEES_ERROR, payload: err });
  }
};

export const getAllClients = () => async dispatch => {
  try {
    dispatch({ type: userActionTypes.GET_ALL_CLIENTS_START });
    const { data } = await api.get('/all-clients');
    dispatch({ type: userActionTypes.GET_ALL_CLIENTS, payload: data });
  } catch (err) {
    dispatch({ type: userActionTypes.GET_ALL_CLIENTS_ERROR, payload: err });
  }
};

export const updateClientProfile = profileData => async dispatch => {
  try {
    dispatch({ type: userActionTypes.UPDATE_CLIENT_START });
    const { data } = await api.patch('/client/profile', profileData);
    dispatch({ type: userActionTypes.UPDATE_CLIENT, payload: data });
  } catch (err) {
    dispatch({ type: userActionTypes.UPDATE_CLIENT_ERROR, payload: err });
  }
};
